import React from 'react';

interface ContactInfoProps {
  email: string;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ email }) => {
  return (
    <div className="flex flex-1 gap-5 items-center px-12 py-7 bg-yellow-400 rounded-3xl max-md:px-5 max-md:py-7 max-sm:px-5 max-sm:py-4 max-w-fit">
      <div className="text-sm font-bold">{email}</div>
    </div>
  );
};

export default ContactInfo;